// // // import Breadcrumb from '@components/Shared/Breadcrumb';
// // // import { Card, CardBody } from '@components/card/card';
// // // import { useTranslation } from 'react-i18next';
// // // import { Link } from 'react-router-dom';
// // // import Loading from '@components/Shared/Loader/Loading';
// // // import useGetApExpenseList from '@hooks/Finance/Expense/useGetApExpenseList';
// // // import NtxTable from '@components/DataTable/NtxTable';

// // // const Index = () => {
// // //   const { t, i18n } = useTranslation();

// // //   const { ApExpenseList, loading, error } = useGetApExpenseList();

// // //   const columns = [
// // //     { title: t('الرقم'), key: 'no', sortable: false },
// // //     { title: t('ExpenseCategory'), key: 'ExpenseCategory', sortable: false },
// // //     { title: t('ExpenseDate'), key: 'ExpenseDate' },
// // //     { title: t('TotalAmount'), key: 'TotalAmount' },
// // //     { title: t('Supplier'), key: 'Supplier' },
// // //     { title: t('وحدة التشغيل'), key: 'organizationName' },
// // //     { title: t('الحالة'), key: 'isConfirmed' },

// // //     { title: '', key: 'action', className: 'text-end' }
// // //   ];

// // //   const tableData = ApExpenseList.map(item => {
// // //     let rowClass;

// // //     return {
// // //       no: item.code,
// // //       ExpenseCategory: i18n.language === 'en' ? item.expenseCategoryName : item.expenseCategoryName2,
// // //       ExpenseDate: item.expenseDate?.split('T')[0],
// // //       TotalAmount: Number(item.totalAmount) + Number(item.totalVat),
// // //       Supplier: i18n.language === 'en' ? item.peopleName : item.peopleName2,
// // //       peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
// // //       organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
// // //       // isConfirmed: item.isConfirmed,
// // //       isConfirmed: (
// // //         <span className={`badge ${item.isConfirmed ? 'bg-success' : 'bg-secondary'}`}>
// // //           {/* {item.isConfirmed ? t('Confirmed') : t('NotConfirmed')} */}
// // //           {item.isConfirmed ? t('Confirmed') : t('مسودة')}
// // //         </span>
// // //       ),

// // //       action: (
// // //         <Link to={`${item.id}/UpdateApExpense`} className='btn btn-sm btn-outline-theme mx-1'>
// // //           <i className='fas fa-info-circle fa-lg  '></i>
// // //         </Link>
// // //       ),
// // //       rowClass // استخدم rowClass هنا
// // //     };
// // //   });

// // //   //____________________________

// // //   return (
// // //     <>
// // //       <div className='d-flex align-items-center  '>
// // //         <Breadcrumb
// // //           BreadcrumbList={[
// // //             {
// // //               name: 'Home',
// // //               link: ':moduleHome'
// // //             },
// // //             {
// // //               name: 'تقرير المصروفات',
// // //               link: null
// // //             }
// // //           ]}
// // //           PageName='تقرير المصروفات'
// // //         />
// // //         {/* <div className='ms-auto'>
// // //           <Link to='AddApExpense' className='btn me-1 btn-theme'>
// // //             <i className='fa fa-plus-circle fa-fw me-1'></i>
// // //             تقرير جديـد
// // //           </Link>
// // //         </div> */}
// // //         <div className='ms-auto' >
// // //           <div className='dropdown' >
// // //             <button
// // //               className='btn me-1 btn-theme dropdown-toggle'
// // //               type='button'
// // //               data-bs-toggle='dropdown'
// // //               aria-expanded='false'
// // //             >
// // //               <i className='fa fa-plus-circle fa-fw me-1'></i>
// // //               تقرير جديـد
// // //             </button>

// // //             <ul className='dropdown-menu dropdown-menu-end'>
// // //               {/* NORMAL */}
// // //               <li>
// // //                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=NORMAL'>
// // //                   <i className='fa fa-file-invoice fa-fw me-2 text-primary'></i>
// // //                   {t('تقرير مصروفات')}
// // //                 </Link>
// // //               </li>

// // //               {/* FAST */}
// // //               <li>
// // //                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=FAST'>
// // //                   <i className='fa fa-bolt fa-fw me-2 text-warning'></i>
// // //                   {t('تقرير مصروفات سريـع')}
// // //                 </Link>
// // //               </li>
// // //             </ul>
// // //           </div>
// // //         </div>
// // //       </div>
// // //       <Card>
// // //         <Loading loading={loading} error={error}>
// // //           <CardBody>
// // //             <div className=' p-2'>
// // //               <NtxTable
// // //                 data={tableData || []}
// // //                 columns={columns}
// // //                 dataPerPage={10}
// // //                 theadClass=''
// // //                 tableClass='table text-nowrap table-hover '
// // //                 enableSearch
// // //                 showRecordsSelector
// // //               />
// // //             </div>
// // //           </CardBody>
// // //         </Loading>
// // //       </Card>
// // //     </>
// // //   );
// // // };

// // // export default Index;

// // import { useEffect, useState } from 'react';
// // import Breadcrumb from '@components/Shared/Breadcrumb';
// // import { Card, CardFooter, CardHeader } from '@components/card/card';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import Loading from '@components/Shared/Loader/Loading';
// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { getPagedData, setEndpoint, setFilters } from '@store/DynamicFilter/dynamicTableSlice';
// // import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// // import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
// // import Select from 'react-select';
// // import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// // import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// // import useGetApExpenseCategoryList from '@hooks/Finance/Expense/useGetApExpenseCategoryList';

// // const TABLE_KEY = 'ApExpense_Index';

// // const Index = () => {
// //   const { t, i18n } = useTranslation();

// //   // ✅ حالة الفلاتر المحلية
// //   const [supplierFilter, setSupplierFilter] = useState<any>(null);
// //   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
// //   const [dateFrom, setDateFrom] = useState('');
// //   const [dateTo, setDateTo] = useState('');
// //   const [categoryFilter, setCategoryFilter] = useState<any>(null);
// //   const [statusFilter, setStatusFilter] = useState<any>(null);
// //   const [showFilters, setShowFilters] = useState(false);

// //   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
// //   const { OptionSuppliers } = useGetSuppliersList();
// //   const { OptionsExpenseCategory } = useGetApExpenseCategoryList();

// //   // ✅ خيارات حالة التقرير
// //   const statusOptions = [
// //     { value: 'confirmed', label: t('Confirmed') },
// //     { value: 'draft', label: t('مسودة') }
// //   ];

// //   const dispatch = useAppDispatch();
// //   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
// //   const data = tableState?.data ?? [];
// //   const loading = tableState?.loading ?? false;
// //   const error = tableState?.error ?? null;
// //   const filters = tableState?.filters ?? [];
// //   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

// //   // ✅ تهيئة الجدول
// //   useEffect(() => {
// //     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Expense/GetApExpenseHeadersList_Paged' }));
// //     dispatch(getPagedData({ tableKey: TABLE_KEY }));
// //   }, [dispatch]);

// //   // ✅ حساب عدد الفلاتر النشطة
// //   useEffect(() => {
// //     setActiveFiltersCount(filters.length);
// //   }, [filters]);

// //   // ✅ دالة إنشاء ID فريد للفلتر
// //   const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

// //   // ✅ دالة تطبيق الفلاتر
// //   const applyFilters = () => {
// //     const newFilters: any[] = [];

// //     if (supplierFilter) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'peopleId',
// //         operator: 0,
// //         value: supplierFilter.value
// //       });
// //     }

// //     if (organizationFilter) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'organizationId',
// //         operator: 0,
// //         value: organizationFilter.value
// //       });
// //     }

// //     if (categoryFilter) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'expenseCategoryId',
// //         operator: 0,
// //         value: categoryFilter.value
// //       });
// //     }

// //     if (statusFilter) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'isConfirmed',
// //         operator: 0,
// //         value: statusFilter.value === 'confirmed'
// //       });
// //     }

// //     if (dateFrom) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'expenseDate',
// //         operator: 3,
// //         value: dateFrom
// //       });
// //     }

// //     if (dateTo) {
// //       newFilters.push({
// //         id: generateFilterId(),
// //         field: 'expenseDate',
// //         operator: 5,
// //         value: dateTo
// //       });
// //     }

// //     dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
// //     dispatch(getPagedData({ tableKey: TABLE_KEY }));
// //   };

// //   // ✅ دالة مسح جميع الفلاتر
// //   const clearFilters = (): void => {
// //     setSupplierFilter(null);
// //     setOrganizationFilter(null);
// //     setCategoryFilter(null);
// //     setStatusFilter(null);
// //     setDateFrom('');
// //     setDateTo('');

// //     dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
// //     dispatch(getPagedData({ tableKey: TABLE_KEY }));
// //   };

// //   // ✅ حقول Dynamic Filter
// //   const fields: any = [
// //     { name: 'code', label: t('الرقم'), type: 'string' },
// //     { name: 'expenseDate', label: t('ExpenseDate'), type: 'date' },
// //     {
// //       name: 'expenseCategoryId',
// //       label: t('ExpenseCategory'),
// //       type: 'options',
// //       options: OptionsExpenseCategory
// //     },
// //     {
// //       name: 'isConfirmed',
// //       label: t('الحالة'),
// //       type: 'options',
// //       options: statusOptions
// //     },
// //     { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
// //     { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
// //     { name: 'totalAmount', label: t('TotalAmount'), type: 'number' },
// //     { name: 'totalVat', label: t('VATAmount'), type: 'number' }
// //   ];

// //   // ✅ دالة لتنسيق المبلغ
// //   const formatAmount = (amount: number) => {
// //     return new Intl.NumberFormat(i18n.language, {
// //       minimumFractionDigits: 2,
// //       maximumFractionDigits: 2
// //     }).format(amount);
// //   };

// //   // ✅ دالة لعرض حالة التقرير
// //   const getStatusBadge = (isConfirmed: boolean) => {
// //     return isConfirmed ? (
// //       <span className='badge bg-success' title={t('Confirmed')}>
// //         <i className='fas fa-check-circle me-1'></i>
// //         مؤكد
// //       </span>
// //     ) : (
// //       <span className='badge bg-secondary' title={t('مسودة')}>
// //         <i className='fas fa-edit me-1'></i>
// //         مسودة
// //       </span>
// //     );
// //   };

// //   // ✅ دالة لعرض رقم التقرير مع تاريخه في عمود واحد
// //   const renderReportWithDate = (code: string, date: string) => {
// //     const formattedDate = date?.split('T')[0] || '';

// //     return (
// //       <div className='d-flex flex-column'>
// //         <div className='fw-bold'>
// //           <span className='text-theme' style={{ letterSpacing: '0.05em' }}>
// //             {code}
// //           </span>
// //         </div>
// //         <small className='text-muted'>
// //           <i className='fas fa-calendar-alt me-1'></i>
// //           {formattedDate}
// //         </small>
// //       </div>
// //     );
// //   };

// //   // ✅ دالة لعرض المورد مع وحدة التشغيل في عمود واحد
// //   const renderSupplierWithOrg = (supplierName: string, orgName: string, supplierCode?: string) => {
// //     return (
// //       <div className='d-flex flex-column'>
// //         <div className='fw-bold'>{supplierName}</div>
// //         {supplierCode && (
// //           <small className='text-muted'>
// //             <i className='fas fa-hashtag me-1'></i>
// //             {supplierCode}
// //           </small>
// //         )}
// //         <small className='text-muted mt-1'>
// //           <i className='fas fa-building me-1'></i>
// //           {orgName}
// //         </small>
// //       </div>
// //     );
// //   };

// //   // ✅ دالة لعرض المبلغ مع الضريبة في عمود واحد
// //   const renderAmountWithVAT = (totalAmount: number, totalVat: number, isConfirmed: boolean) => {
// //     const total = Number(totalAmount) + Number(totalVat);
// //     const baseClass = isConfirmed ? '' : 'opacity-75';

// //     return (
// //       <div className='d-flex flex-column'>
// //         <span className={`fw-bold fs-6 text-theme ${baseClass}`}>{formatAmount(total)}</span>
// //         <small className={`text-muted mt-1 ${baseClass}`}>
// //           <i className='fas fa-receipt me-1'></i>
// //           شامل الضريبة: {formatAmount(totalVat)}
// //         </small>
// //       </div>
// //     );
// //   };

// //   // ✅ دالة لعرض فئة المصروفات مع الحالة في عمود واحد
// //   const renderCategoryWithStatus = (categoryName: string, isConfirmed: boolean) => {
// //     const baseClass = isConfirmed ? '' : 'opacity-75';

// //     return (
// //       <div className='d-flex flex-column'>
// //         <div className={`fw-bold ${baseClass}`}>{categoryName}</div>
// //         <div className='mt-1'>{getStatusBadge(isConfirmed)}</div>
// //       </div>
// //     );
// //   };

// //   const breadcrumbList = [
// //     { name: t('Home'), link: ':moduleHome' },
// //     { name: t('تقرير المصروفات'), link: null }
// //   ];

// //   return (
// //     <>
// //       <div className='d-flex flex-wrap align-items-center gap-2'>
// //         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('تقرير المصروفات')} />
// //         <div className='ms-auto'>
// //           <div className='dropdown'>
// //             <button
// //               className='btn btn-theme dropdown-toggle'
// //               type='button'
// //               data-bs-toggle='dropdown'
// //               aria-expanded='false'
// //             >
// //               <i className='fa fa-plus-circle fa-fw me-1'></i>
// //               تقرير جديـد
// //             </button>

// //             <ul className='dropdown-menu dropdown-menu-end'>
// //               {/* NORMAL */}
// //               <li>
// //                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=NORMAL'>
// //                   <i className='fa fa-file-invoice fa-fw me-2 text-primary'></i>
// //                   {t('تقرير مصروفات')}
// //                 </Link>
// //               </li>

// //               {/* FAST */}
// //               <li>
// //                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=FAST'>
// //                   <i className='fa fa-bolt fa-fw me-2 text-warning'></i>
// //                   {t('تقرير مصروفات سريـع')}
// //                 </Link>
// //               </li>
// //             </ul>
// //           </div>
// //         </div>
// //       </div>

// //       <Card className='mb-4'>
// //         <CardHeader>
// //           <div className='row g-2'>
// //             {/* ✅ فلترة بوحدة التشغيل */}
// //             <div className='col-lg-3'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-building'></i>
// //                 </span>
// //                 <Select
// //                   value={organizationFilter}
// //                   onChange={setOrganizationFilter}
// //                   options={OperatingUnitOptions}
// //                   placeholder={t('اختر وحدة تشغيـل')}
// //                   isClearable
// //                   isSearchable
// //                   className='flex-grow-1'
// //                   classNamePrefix='react-select'
// //                   menuPortalTarget={document.body}
// //                   styles={{
// //                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
// //                   }}
// //                 />
// //               </div>
// //             </div>

// //             {/* ✅ فلترة بالمورد */}
// //             <div className='col-lg-3'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-truck'></i>
// //                 </span>
// //                 <Select
// //                   value={supplierFilter}
// //                   onChange={setSupplierFilter}
// //                   options={OptionSuppliers}
// //                   placeholder={t('اختر مورد')}
// //                   isClearable
// //                   isSearchable
// //                   className='flex-grow-1'
// //                   classNamePrefix='react-select'
// //                   menuPortalTarget={document.body}
// //                   styles={{
// //                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
// //                   }}
// //                 />
// //               </div>
// //             </div>

// //             {/* ✅ فلترة بفئة المصروفات */}
// //             <div className='col-lg-3'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-tags'></i>
// //                 </span>
// //                 <Select
// //                   value={categoryFilter}
// //                   onChange={setCategoryFilter}
// //                   options={OptionsExpenseCategory}
// //                   placeholder={t('اختر فئة مصروفات')}
// //                   isClearable
// //                   isSearchable
// //                   className='flex-grow-1'
// //                   classNamePrefix='react-select'
// //                   menuPortalTarget={document.body}
// //                   styles={{
// //                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
// //                   }}
// //                 />
// //               </div>
// //             </div>

// //             {/* ✅ فلترة بالحالة */}
// //             <div className='col-lg-3'>
// //               <div className='input-group'>
// //                 <span className='input-group-text fw-bold'>
// //                   <i className='fas fa-info-circle'></i>
// //                 </span>
// //                 <Select
// //                   value={statusFilter}
// //                   onChange={setStatusFilter}
// //                   options={statusOptions}
// //                   placeholder={t('الحالة')}
// //                   isClearable
// //                   isSearchable
// //                   className='flex-grow-1'
// //                   classNamePrefix='react-select'
// //                   menuPortalTarget={document.body}
// //                   styles={{
// //                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
// //                   }}
// //                 />
// //               </div>
// //             </div>

// //             {/* ✅ التاريخ من وإلى */}
// //             <div className='col-lg-6'>
// //               <div className='input-group'>
// //                 <span className='input-group-text'>
// //                   <i className='fas fa-calendar-alt text-muted'></i>
// //                 </span>
// //                 <input
// //                   type='date'
// //                   className='form-control border-start-0'
// //                   value={dateFrom}
// //                   onChange={e => setDateFrom(e.target.value)}
// //                   placeholder={t('من')}
// //                 />
// //                 <span className='input-group-text'>-</span>
// //                 <input
// //                   type='date'
// //                   className='form-control'
// //                   value={dateTo}
// //                   onChange={e => setDateTo(e.target.value)}
// //                   placeholder={t('إلى')}
// //                 />
// //               </div>
// //             </div>

// //             {/* ✅ أزرار التطبيق والمسح */}
// //             <div className='col-lg-6 text-end'>
// //               <button
// //                 className='btn btn-outline-secondary me-2'
// //                 type='button'
// //                 onClick={clearFilters}
// //                 title={t('ClearFilters')}
// //                 disabled={activeFiltersCount === 0}
// //               >
// //                 <i className='fas fa-times fa-fw'></i>
// //               </button>
// //               <button
// //                 className='btn btn-theme me-2'
// //                 type='button'
// //                 onClick={applyFilters}
// //                 title={t('ApplyFilters')}
// //                 disabled={
// //                   !supplierFilter && !organizationFilter && !categoryFilter && !statusFilter && !dateFrom && !dateTo
// //                 }
// //               >
// //                 <i className='fas fa-filter fa-fw'></i>
// //               </button>
// //               <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
// //                 <i className='fas fa-sliders-h fa-fw'></i>
// //               </button>
// //             </div>
// //           </div>
// //         </CardHeader>

// //         <Loading loading={loading} error={error}>
// //           <div className='table-responsive'>
// //             <table className='table table-hover mb-0'>
// //               <thead className='bg-theme bg-opacity-25 fw-bold'>
// //                 <tr>
// //                   <th className='small'>رقم التقرير / التاريخ</th>
// //                   <th className='small'>فئة المصروفات / الحالة</th>
// //                   <th className='small'>المبلغ شامل الضريبة</th>
// //                   <th className='small'>المورد / وحدة التشغيل</th>
// //                   <th className='small text-center'>الإجراءات</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {data.length > 0 ? (
// //                   data.map((item: any) => {
// //                     const categoryName = i18n.language === 'en' ? item.expenseCategoryName : item.expenseCategoryName2;
// //                     const supplierName = i18n.language === 'en' ? item.peopleName : item.peopleName2;
// //                     const orgName = i18n.language === 'en' ? item.organizationName : item.organizationName2;

// //                     return (
// //                       // <tr key={item.id} className={item.isConfirmed ? '' : 'bg-light bg-opacity-25'}>
// //                       <tr key={item.id} className={item.isConfirmed ? '' : ''}>
// //                         <td className='align-middle'>{renderReportWithDate(item.code, item.expenseDate)}</td>
// //                         <td className='align-middle'>{renderCategoryWithStatus(categoryName, item.isConfirmed)}</td>
// //                         <td className='align-middle'>
// //                           {renderAmountWithVAT(item.totalAmount, item.totalVat, item.isConfirmed)}
// //                         </td>
// //                         <td className='align-middle'>
// //                           {renderSupplierWithOrg(supplierName, orgName, item.peopleCode)}
// //                         </td>
// //                         <td className='align-middle text-end'>
// //                           <div className='d-flex justify-content-end gap-2'>
// //                             <Link
// //                               to={`${item.id}/UpdateApExpense`}
// //                               className={`btn btn-sm ${item.isConfirmed ? 'btn-outline-theme' : 'btn-outline-secondary'}`}
// //                               title={t('ViewDetails')}
// //                             >
// //                               <i className={`bi bi-info-circle fa-lg me-1 ${item.isConfirmed ? '' : 'text-muted'}`}></i>
// //                               {item.isConfirmed ? 'تفاصيل' : 'استكمال'}
// //                             </Link>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     );
// //                   })
// //                 ) : (
// //                   <tr>
// //                     <td colSpan={5} className='text-center py-5 text-muted'>
// //                       <div className='py-4'>
// //                         <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
// //                         <h5 className='mb-2'>
// //                           {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoExpenseReports')}
// //                         </h5>
// //                         <p className='text-muted small'>
// //                           {activeFiltersCount > 0
// //                             ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر'
// //                             : 'لا توجد تقارير مصروفات مسجلة في النظام'}
// //                         </p>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>
// //         </Loading>

// //         <CardFooter>
// //           <div className='text-theme'>
// //             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
// //           </div>
// //         </CardFooter>
// //       </Card>

// //       <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
// //     </>
// //   );
// // };

// // export default Index;

// import { useEffect, useMemo, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import {
//   getPagedData,
//   setEndpoint,
//   setFilters,
//   setFixedFilters // ✅ مهم
// } from '@store/DynamicFilter/dynamicTableSlice';
// import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import useGetApExpenseCategoryList from '@hooks/Finance/Expense/useGetApExpenseCategoryList';

// const TABLE_KEY = 'ApExpense_Index';

// const Index = () => {
//   const { t, i18n } = useTranslation();

//   // ✅ حالة الفلاتر المحلية
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [categoryFilter, setCategoryFilter] = useState<any>(null);

//   // ✅ الحالة (ثابتة fixedFilters)
//   const [statusFilter, setStatusFilter] = useState<any>(null);

//   const [showFilters, setShowFilters] = useState(false);

//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();
//   const { OptionsExpenseCategory } = useGetApExpenseCategoryList();

//   // ✅ خيارات حالة التقرير (Boolean)
//   const statusOptions = useMemo(
//     () => [
//       { value: true, label: t('Confirmed') },
//       { value: false, label: t('مسودة') }
//     ],
//     [t]
//   );

//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
//   const data = tableState?.data ?? [];
//   const loading = tableState?.loading ?? false;
//   const error = tableState?.error ?? null;
//   const filters = tableState?.filters ?? [];
//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   // ✅ تهيئة الجدول
//   useEffect(() => {
//     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Expense/GetApExpenseHeadersList_Paged' }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   }, [dispatch]);

//   // ✅ مزامنة فلتر الحالة من fixedFilters إلى الـ UI (لو كان موجود مسبقًا)
//   useEffect(() => {
//     const val = tableState?.fixedFilters?.isConfirmed;

//     if (val === true || val === false) {
//       // لو الـ UI ما يعكس القيمة
//       if (statusFilter?.value !== val) {
//         setStatusFilter(val ? statusOptions[0] : statusOptions[1]);
//       }
//     } else {
//       // لو السيرفر ما فيه قيمة وثابتة، رجّع الـ UI إلى null
//       if (statusFilter != null) setStatusFilter(null);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tableState?.fixedFilters?.isConfirmed, statusOptions]);

//   // ✅ حساب عدد الفلاتر النشطة (filters[] + fixedFilters)
//   useEffect(() => {
//     const fixed = tableState?.fixedFilters ?? {};
//     const fixedCount = Object.keys(fixed).filter(k => fixed[k] !== undefined && fixed[k] !== null && fixed[k] !== '').length;
//     setActiveFiltersCount(filters.length + fixedCount);
//   }, [filters, tableState?.fixedFilters]);

//   // ✅ دالة إنشاء ID فريد للفلتر
//   const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//   // ✅ دالة تطبيق الفلاتر
//   const applyFilters = () => {
//     const newFilters: any[] = [];

//     if (supplierFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'peopleId',
//         operator: 0,
//         value: supplierFilter.value
//       });
//     }

//     if (organizationFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'organizationId',
//         operator: 0,
//         value: organizationFilter.value
//       });
//     }

//     if (categoryFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'expenseCategoryId',
//         operator: 0,
//         value: categoryFilter.value
//       });
//     }

//     // ✅ التاريخ من وإلى
//     if (dateFrom) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'expenseDate',
//         operator: 3, // >=
//         value: dateFrom
//       });
//     }

//     if (dateTo) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'expenseDate',
//         operator: 5, // <=
//         value: dateTo
//       });
//     }

//     // ✅ الحالة كـ fixedFilters (isConfirmed)
//     const nextFixed = { ...(tableState?.fixedFilters ?? {}) };

//     if (statusFilter?.value === true || statusFilter?.value === false) {
//       nextFixed.isConfirmed = statusFilter.value;
//     } else {
//       delete nextFixed.isConfirmed;
//     }

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
//     dispatch(setFixedFilters({ tableKey: TABLE_KEY, fixedFilters: nextFixed }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ دالة مسح جميع الفلاتر
//   const clearFilters = (): void => {
//     setSupplierFilter(null);
//     setOrganizationFilter(null);
//     setCategoryFilter(null);
//     setStatusFilter(null);
//     setDateFrom('');
//     setDateTo('');

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));

//     const nextFixed = { ...(tableState?.fixedFilters ?? {}) };
//     delete nextFixed.isConfirmed;
//     dispatch(setFixedFilters({ tableKey: TABLE_KEY, fixedFilters: nextFixed }));

//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ حقول Dynamic Filter (بدون isConfirmed حتى لا يتكرر)
//   const fields: any = [
//     { name: 'code', label: t('الرقم'), type: 'string' },
//     { name: 'expenseDate', label: t('ExpenseDate'), type: 'date' },
//     {
//       name: 'expenseCategoryId',
//       label: t('ExpenseCategory'),
//       type: 'options',
//       options: OptionsExpenseCategory
//     },
//     { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
//     { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
//     { name: 'totalAmount', label: t('TotalAmount'), type: 'number' },
//     { name: 'totalVat', label: t('VATAmount'), type: 'number' }
//   ];

//   // ✅ دالة لتنسيق المبلغ
//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   // ✅ دالة لعرض حالة التقرير
//   const getStatusBadge = (isConfirmed: boolean) => {
//     return isConfirmed ? (
//       <span className='badge bg-success' title={t('Confirmed')}>
//         <i className='fas fa-check-circle me-1'></i>
//         مؤكد
//       </span>
//     ) : (
//       <span className='badge bg-secondary' title={t('مسودة')}>
//         <i className='fas fa-edit me-1'></i>
//         مسودة
//       </span>
//     );
//   };

//   // ✅ دالة لعرض رقم التقرير مع تاريخه في عمود واحد
//   const renderReportWithDate = (code: string, date: string) => {
//     const formattedDate = date?.split('T')[0] || '';

//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold'>
//           <span className='text-theme' style={{ letterSpacing: '0.05em' }}>
//             {code}
//           </span>
//         </div>
//         <small className='text-muted'>
//           <i className='fas fa-calendar-alt me-1'></i>
//           {formattedDate}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض المورد مع وحدة التشغيل في عمود واحد
//   const renderSupplierWithOrg = (supplierName: string, orgName: string, supplierCode?: string) => {
//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold'>{supplierName}</div>
//         {supplierCode && (
//           <small className='text-muted'>
//             <i className='fas fa-hashtag me-1'></i>
//             {supplierCode}
//           </small>
//         )}
//         <small className='text-muted mt-1'>
//           <i className='fas fa-building me-1'></i>
//           {orgName}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض المبلغ مع الضريبة في عمود واحد
//   const renderAmountWithVAT = (totalAmount: number, totalVat: number, isConfirmed: boolean) => {
//     const total = Number(totalAmount) + Number(totalVat);
//     const baseClass = isConfirmed ? '' : 'opacity-75';

//     return (
//       <div className='d-flex flex-column'>
//         <span className={`fw-bold fs-6 text-theme ${baseClass}`}>{formatAmount(total)}</span>
//         <small className={`text-muted mt-1 ${baseClass}`}>
//           <i className='fas fa-receipt me-1'></i>
//           شامل الضريبة: {formatAmount(totalVat)}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض فئة المصروفات مع الحالة في عمود واحد
//   const renderCategoryWithStatus = (categoryName: string, isConfirmed: boolean) => {
//     const baseClass = isConfirmed ? '' : 'opacity-75';

//     return (
//       <div className='d-flex flex-column'>
//         <div className={`fw-bold ${baseClass}`}>{categoryName}</div>
//         <div className='mt-1'>{getStatusBadge(isConfirmed)}</div>
//       </div>
//     );
//   };

//   const breadcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('تقرير المصروفات'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('تقرير المصروفات')} />
//         <div className='ms-auto'>
//           <div className='dropdown'>
//             <button className='btn btn-theme dropdown-toggle' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               تقرير جديـد
//             </button>

//             <ul className='dropdown-menu dropdown-menu-end'>
//               <li>
//                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=NORMAL'>
//                   <i className='fa fa-file-invoice fa-fw me-2 text-primary'></i>
//                   {t('تقرير مصروفات')}
//                 </Link>
//               </li>

//               <li>
//                 <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=FAST'>
//                   <i className='fa fa-bolt fa-fw me-2 text-warning'></i>
//                   {t('تقرير مصروفات سريـع')}
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* ✅ فلترة بوحدة التشغيل */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <Select
//                   value={organizationFilter}
//                   onChange={setOrganizationFilter}
//                   options={OperatingUnitOptions}
//                   placeholder={t('اختر وحدة تشغيـل')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالمورد */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <Select
//                   value={supplierFilter}
//                   onChange={setSupplierFilter}
//                   options={OptionSuppliers}
//                   placeholder={t('اختر مورد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بفئة المصروفات */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-tags'></i>
//                 </span>
//                 <Select
//                   value={categoryFilter}
//                   onChange={setCategoryFilter}
//                   options={OptionsExpenseCategory}
//                   placeholder={t('اختر فئة مصروفات')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالحالة (fixedFilters.isConfirmed) */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-info-circle'></i>
//                 </span>
//                 <Select
//                   value={statusFilter}
//                   onChange={setStatusFilter}
//                   options={statusOptions}
//                   placeholder={t('الحالة')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ من وإلى */}
//             <div className='col-lg-6'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('من')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input
//                   type='date'
//                   className='form-control'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                   placeholder={t('إلى')}
//                 />
//               </div>
//             </div>

//             {/* ✅ أزرار التطبيق والمسح */}
//             <div className='col-lg-6 text-end'>
//               <button
//                 className='btn btn-outline-secondary me-2'
//                 type='button'
//                 onClick={clearFilters}
//                 title={t('ClearFilters')}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-times fa-fw'></i>
//               </button>

//               <button
//                 className='btn btn-theme me-2'
//                 type='button'
//                 onClick={applyFilters}
//                 title={t('ApplyFilters')}
//                 disabled={!supplierFilter && !organizationFilter && !categoryFilter && !statusFilter && !dateFrom && !dateTo}
//               >
//                 <i className='fas fa-filter fa-fw'></i>
//               </button>

//               <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
//                 <i className='fas fa-sliders-h fa-fw'></i>
//               </button>
//             </div>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-25 fw-bold'>
//                 <tr>
//                   <th className='small'>رقم التقرير / التاريخ</th>
//                   <th className='small'>فئة المصروفات / الحالة</th>
//                   <th className='small'>المبلغ شامل الضريبة</th>
//                   <th className='small'>المورد / وحدة التشغيل</th>
//                   <th className='small text-center'>الإجراءات</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {data.length > 0 ? (
//                   data.map((item: any) => {
//                     const categoryName = i18n.language === 'en' ? item.expenseCategoryName : item.expenseCategoryName2;
//                     const supplierName = i18n.language === 'en' ? item.peopleName : item.peopleName2;
//                     const orgName = i18n.language === 'en' ? item.organizationName : item.organizationName2;

//                     return (
//                       <tr key={item.id} className={item.isConfirmed ? '' : ''}>
//                         <td className='align-middle'>{renderReportWithDate(item.code, item.expenseDate)}</td>
//                         <td className='align-middle'>{renderCategoryWithStatus(categoryName, item.isConfirmed)}</td>
//                         <td className='align-middle'>{renderAmountWithVAT(item.totalAmount, item.totalVat, item.isConfirmed)}</td>
//                         <td className='align-middle'>{renderSupplierWithOrg(supplierName, orgName, item.peopleCode)}</td>
//                         <td className='align-middle text-end'>
//                           <div className='d-flex justify-content-end gap-2'>
//                             <Link
//                               to={`${item.id}/UpdateApExpense`}
//                               className={`btn btn-sm ${item.isConfirmed ? 'btn-outline-theme' : 'btn-outline-secondary'}`}
//                               title={t('ViewDetails')}
//                             >
//                               <i className={`bi bi-info-circle fa-lg me-1 ${item.isConfirmed ? '' : 'text-muted'}`}></i>
//                               {item.isConfirmed ? 'تفاصيل' : 'استكمال'}
//                             </Link>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={5} className='text-center py-5 text-muted'>
//                       <div className='py-4'>
//                         <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
//                         <h5 className='mb-2'>{activeFiltersCount > 0 ? t('NoSearchResults') : t('NoExpenseReports')}</h5>
//                         <p className='text-muted small'>
//                           {activeFiltersCount > 0 ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر' : 'لا توجد تقارير مصروفات مسجلة في النظام'}
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme'>
//             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
//     </>
//   );
// };

// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;
// export default Index;

import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  getPagedData,
  setEndpoint,
  setFilters,
  setFixedFilters // ✅ مهم لفلتر الحالة كـ fixedFilters
} from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import Select from 'react-select';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetApExpenseCategoryList from '@hooks/Finance/Expense/useGetApExpenseCategoryList';

const TABLE_KEY = 'ApExpense_Index';

const Index = () => {
  const { t, i18n } = useTranslation();

  // ✅ حالة الفلاتر المحلية
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [categoryFilter, setCategoryFilter] = useState<any>(null);

  // ✅ الحالة (ثابتة fixedFilters)
  const [statusFilter, setStatusFilter] = useState<any>(null);

  const [showFilters, setShowFilters] = useState(false);

  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  // const { OptionSuppliers } = useGetSuppliersList();
  const { OptionsExpenseCategory } = useGetApExpenseCategoryList();

  // ✅ خيارات حالة التقرير (Boolean)
  const statusOptions = useMemo(
    () => [
      { value: true, label: t('Confirmed') },
      { value: false, label: t('مسودة') }
    ],
    [t]
  );

  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ✅ تهيئة الجدول
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Expense/GetApExpenseHeadersList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  // ✅ مزامنة فلتر الحالة من fixedFilters إلى UI
  useEffect(() => {
    const val = tableState?.fixedFilters?.isConfirmed;

    if (val === true || val === false) {
      if (statusFilter?.value !== val) {
        setStatusFilter(val ? statusOptions[0] : statusOptions[1]);
      }
    } else {
      if (statusFilter != null) setStatusFilter(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableState?.fixedFilters?.isConfirmed, statusOptions]);

  // ✅ حساب عدد الفلاتر النشطة (filters[] + fixedFilters)
  useEffect(() => {
    const fixed = tableState?.fixedFilters ?? {};
    const fixedCount = Object.keys(fixed).filter(k => fixed[k] !== undefined && fixed[k] !== null && fixed[k] !== '').length;
    setActiveFiltersCount(filters.length + fixedCount);
  }, [filters, tableState?.fixedFilters]);

  // ✅ دالة إنشاء ID فريد للفلتر
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // ✅ دالة تطبيق الفلاتر
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (supplierFilter) {
      newFilters.push({ id: generateFilterId(), field: 'peopleId', operator: 0, value: supplierFilter.value });
    }

    if (organizationFilter) {
      newFilters.push({ id: generateFilterId(), field: 'organizationId', operator: 0, value: organizationFilter.value });
    }

    if (categoryFilter) {
      newFilters.push({ id: generateFilterId(), field: 'expenseCategoryId', operator: 0, value: categoryFilter.value });
    }

    if (dateFrom) {
      newFilters.push({ id: generateFilterId(), field: 'expenseDate', operator: 3, value: dateFrom }); // >=
    }

    if (dateTo) {
      newFilters.push({ id: generateFilterId(), field: 'expenseDate', operator: 5, value: dateTo }); // <=
    }

    // ✅ الحالة كـ fixedFilters (isConfirmed)
    const nextFixed = { ...(tableState?.fixedFilters ?? {}) };
    if (statusFilter?.value === true || statusFilter?.value === false) {
      nextFixed.isConfirmed = statusFilter.value;
    } else {
      delete nextFixed.isConfirmed;
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(setFixedFilters({ tableKey: TABLE_KEY, fixedFilters: nextFixed }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح جميع الفلاتر
  const clearFilters = (): void => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setCategoryFilter(null);
    setStatusFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));

    const nextFixed = { ...(tableState?.fixedFilters ?? {}) };
    delete nextFixed.isConfirmed;
    dispatch(setFixedFilters({ tableKey: TABLE_KEY, fixedFilters: nextFixed }));

    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ حقول Dynamic Filter (بدون isConfirmed حتى لا يتكرر مع fixed)
  const fields: any = [
    { name: 'no', label: t('التسلسل'), type: 'number' },
    { name: 'code', label: t('الرقم'), type: 'string' },
    { name: 'expenseDate', label: t('ExpenseDate'), type: 'date' },
    {
      name: 'expenseCategoryId',
      label: t('ExpenseCategory'),
      type: 'options',
      options: OptionsExpenseCategory
    },
    // { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'totalAmount', label: t('TotalAmount'), type: 'number' },
    { name: 'totalVat', label: t('الضريبة'), type: 'number' }
  ];

  // ✅ دالة لتنسيق المبلغ
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // ✅ دالة لاختيار الوصف حسب اللغة (description/description2)
  const pickLocalizedText = (enText?: string, arText?: string) => {
    const preferred = i18n.language === 'en' ? enText : arText;
    const fallback = i18n.language === 'en' ? arText : enText;
    return (preferred ?? fallback ?? '').trim();
  };

  // ✅ عرض الوصف (مع تقصير + Tooltip)
  const renderDescription = (desc?: string) => {
    if (!desc) return <span className='text-muted'>-</span>;

    return (
      <div className='text-truncate' style={{ maxWidth: 320 }} title={desc}>
        <i className='fas fa-align-left me-1 text-muted'></i>
        {desc}
      </div>
    );
  };

  // ✅ دالة لعرض حالة التقرير
  const getStatusBadge = (isConfirmed: boolean) => {
    return isConfirmed ? (
      <span className='badge bg-success' title={t('Confirmed')}>
        <i className='fas fa-check-circle me-1'></i>
        مؤكد
      </span>
    ) : (
      <span className='badge bg-secondary' title={t('مسودة')}>
        <i className='fas fa-edit me-1'></i>
        مسودة
      </span>
    );
  };

  // ✅ دالة لعرض رقم التقرير مع تاريخه + (الوصف على الجوال فقط)
  const renderReportWithDate = (code: string, date: string, descriptionMobile?: string) => {
    const formattedDate = date?.split('T')[0] || '';

    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold'>
          <span className='text-theme' style={{ letterSpacing: '0.05em' }}>
            {code}
          </span>
        </div>

        <small className='text-muted'>
          <i className='fas fa-calendar-alt me-1'></i>
          {formattedDate}
        </small>

        {/* ✅ على الجوال فقط: نعرض الوصف تحت الكود */}
        {descriptionMobile ? (
          <small className='text-muted text-truncate mt-1 d-lg-none' style={{ maxWidth: 260 }} title={descriptionMobile}>
            <i className='fas fa-align-left me-1'></i>
            {descriptionMobile}
          </small>
        ) : null}
      </div>
    );
  };

  // ✅ دالة لعرض المورد مع وحدة التشغيل في عمود واحد
  const renderSupplierWithOrg = (supplierName: string, orgName: string, supplierCode?: string) => {
    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold'>{supplierName}</div>
        {supplierCode && (
          <small className='text-muted'>
            <i className='fas fa-hashtag me-1'></i>
            {supplierCode}
          </small>
        )}
        <small className='text-muted mt-1'>
          <i className='fas fa-building me-1'></i>
          {orgName}
        </small>
      </div>
    );
  };

  // ✅ دالة لعرض المبلغ مع الضريبة في عمود واحد
  const renderAmountWithVAT = (totalAmount: number, totalVat: number, isConfirmed: boolean) => {
    const total = Number(totalAmount) + Number(totalVat);
    const baseClass = isConfirmed ? '' : 'opacity-75';

    return (
      <div className='d-flex flex-column'>
        <span className={`fw-bold fs-6 text-theme ${baseClass}`}>{formatAmount(total)}</span>
        <small className={`text-muted mt-1 ${baseClass}`}>
          <i className='fas fa-receipt me-1'></i>
           الضريبة: {formatAmount(totalVat)}
        </small>
      </div>
    );
  };

  // ✅ دالة لعرض فئة المصروفات مع الحالة في عمود واحد
  const renderCategoryWithStatus = (categoryName: string, isConfirmed: boolean) => {
    const baseClass = isConfirmed ? '' : 'opacity-75';

    return (
      <div className='d-flex flex-column'>
        <div className={`fw-bold ${baseClass}`}>{categoryName}</div>
        <div className='mt-1'>{getStatusBadge(isConfirmed)}</div>
      </div>
    );
  };

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('تقرير المصروفات'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('تقرير المصروفات')} />
        <div className='ms-auto'>
          <div className='dropdown'>
            <button className='btn btn-theme dropdown-toggle' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              تقرير جديـد
            </button>

            <ul className='dropdown-menu dropdown-menu-end'>
              <li>
                <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=NORMAL'>
                  <i className='fa fa-file-invoice fa-fw me-2 text-primary'></i>
                  {t('تقرير مصروفات')}
                </Link>
              </li>

              <li>
                <Link className='dropdown-item d-flex align-items-center' to='AddApExpense?type=FAST'>
                  <i className='fa fa-bolt fa-fw me-2 text-warning'></i>
                  {t('تقرير مصروفات سريـع')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ فلترة بوحدة التشغيل */}
            <div className='col-lg-5'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالمورد */}
            {/* <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div> */}

            {/* ✅ فلترة بفئة المصروفات */}
            <div className='col-lg-5'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-tags'></i>
                </span>
                <Select
                  value={categoryFilter}
                  onChange={setCategoryFilter}
                  options={OptionsExpenseCategory}
                  placeholder={t('اختر فئة مصروفات')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالحالة (fixedFilters.isConfirmed) */}
            <div className='col-lg-2'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-info-circle'></i>
                </span>
                <Select
                  value={statusFilter}
                  onChange={setStatusFilter}
                  options={statusOptions}
                  placeholder={t('الحالة')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ التاريخ من وإلى */}
            <div className='col-lg-6'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('من')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('إلى')}
                />
              </div>
            </div>

            {/* ✅ أزرار التطبيق والمسح */}
            <div className='col-lg-6 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!supplierFilter && !organizationFilter && !categoryFilter && !statusFilter && !dateFrom && !dateTo}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>رقم التقرير / التاريخ</th>
                  <th className='small'>فئة المصروفات / الحالة</th>

                  {/* ✅ عمود الوصف يظهر فقط على الشاشات الكبيرة */}
                  <th className='small d-none d-lg-table-cell'>الوصف</th>

                  {/* <th className='small'>المبلغ شامل الضريبة</th> */}
                  <th className='small'>المبلغ</th>
                  <th className='small'>المورد / وحدة التشغيل</th>
                  <th className='small text-center'>الإجراءات</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const categoryName = i18n.language === 'en' ? item.expenseCategoryName : item.expenseCategoryName2;
                    const supplierName = i18n.language === 'en' ? item.peopleName : item.peopleName2;
                    const orgName = i18n.language === 'en' ? item.organizationName : item.organizationName2;

                    // ✅ الوصف (يفترض description / description2)
                    const descriptionText = pickLocalizedText(item.description, item.description2);

                    return (
                      <tr key={item.id} className={item.isConfirmed ? '' : ''}>
                        <td className='align-middle'>
                          {renderReportWithDate(item.code, item.expenseDate, descriptionText)}
                        </td>

                        <td className='align-middle'>{renderCategoryWithStatus(categoryName, item.isConfirmed)}</td>

                        {/* ✅ على الشاشات الكبيرة فقط */}
                        <td className='align-middle d-none d-lg-table-cell'>{renderDescription(descriptionText)}</td>

                        <td className='align-middle'>{renderAmountWithVAT(item.totalAmount, item.totalVat, item.isConfirmed)}</td>

                        <td className='align-middle'>{renderSupplierWithOrg(supplierName, orgName, item.peopleCode)}</td>

                        <td className='align-middle text-end'>
                          <div className='d-flex justify-content-end gap-2'>
                            <Link
                              to={`${item.id}/UpdateApExpense`}
                              className={`btn btn-sm ${item.isConfirmed ? 'btn-outline-theme' : 'btn-outline-secondary'}`}
                              title={t('ViewDetails')}
                            >
                              <i className={`bi bi-info-circle fa-lg me-1 ${item.isConfirmed ? '' : 'text-muted'}`}></i>
                              {item.isConfirmed ? 'تفاصيل' : 'استكمال'}
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-5 text-muted'>
                      <div className='py-4'>
                        <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h5 className='mb-2'>{activeFiltersCount > 0 ? t('NoSearchResults') : t('NoExpenseReports')}</h5>
                        <p className='text-muted small'>
                          {activeFiltersCount > 0 ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر' : 'لا توجد تقارير مصروفات مسجلة في النظام'}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
    </>
  );
};

export default Index;
